// extracted by mini-css-extract-plugin
module.exports = {"comp":"EditorMessage_comp__rKkGv"};